"use client";

import "./globals.css";
import { useEffect } from "react";
import SomethingWentWrong from "@/components/notFoundComponents/somethingWentWrong";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Optionally log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
      </head>
      <body className="flex flex-col h-screen bg-white text-black">
        <header className=""></header>
        <div className="flex flex-col items-center flex-1 overflow-auto w-full">
          <main className="flex-1">
            <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8 space-y-8 text-center sm:max-w-md">
              <SomethingWentWrong />
            </div>
          </main>

          <footer className="w-full">
            {/* No risky footer */}
            {/* <Footer
              termsOfServiceUrl={"https://www.clover.com/terms"}
              privacyPolicyUrl={"https://www.clover.com/privacy-policy"}
              googlePlayUrl={
                "https://play.google.com/store/apps/details?id=com.getperka.android&hl=en_US"
              }
              appStoreUrl={"https://apps.apple.com/us/app/clover/id428620381"}
              learnMoreUrl={
                "https://www.clover.com/pos-solutions/clover-ordering-websites"
              }
              languageString={''}
            /> */}
          </footer>
        </div>
      </body>
    </html>
  );
}
